<template>
  <div id="app">
    <!-- KissMora global UI layer -->
    <SplashLoader v-if="showSplash" :duration="1500" @done="showSplash=false"/>
    <TopProgress/>
    <RouteLoader/>
    <KmToast/>
    <DesktopNav/>
    <NotificationBell/>
    <SupportFab/>

    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
import SplashLoader from './components/SplashLoader.vue'
import TopProgress  from './components/TopProgress.vue'
import KmToast      from './components/KmToast.vue'
import DesktopNav   from './components/DesktopNav.vue'
import RouteLoader  from './components/RouteLoader.vue'
import SupportFab   from './components/SupportFab.vue'
import NotificationBell from './components/NotificationBell.vue'
import { normalizeLocale, applySiteLocale } from '@/common/locale'

// Routes that should NOT trigger the "you must login" redirect.
const PUBLIC_ROUTES = ['/', '/Login', '/Register', '/Login-legacy', '/Register-legacy'];

export default {
  name: 'app',
  components: { Footer, SplashLoader, TopProgress, KmToast, DesktopNav, RouteLoader, SupportFab, NotificationBell },
  data() {
    return {
      status: 0,
      // Only show the branded splash once per session (not on every HMR refresh of an inner page)
      showSplash: !sessionStorage.getItem('km_splash_seen')
    };
  },
  methods: {
    syncLang(){
      return this.$http({
        method: 'get',
        url: 'replaceLang',
        data: { lang: this.$i18n.locale }
      });
    },
    getBaseInfo(){
      this.$http({ method: 'get', url: 'base_info' }).then(res => {
        if(!localStorage.getItem('token')){
          // Public routes stay public — don't force the login page.
          const p = this.$route && this.$route.path;
          if(!PUBLIC_ROUTES.some(r => r.toLowerCase() === (p || '').toLowerCase())){
            this.$router.push({ path: '/Login' });
          }
        }
        if(res && res.data) this.$store.commit('setBaseInfoValue', res.data);
      });
    }
  },
  created(){
    applySiteLocale(this.$i18n, normalizeLocale(localStorage.getItem('lang') || 'en'));
    const run = () => this.getBaseInfo();
    this.syncLang().then(run, run);
    // Mark splash as seen so navigating between pages doesn't re-trigger it.
    sessionStorage.setItem('km_splash_seen', '1');
  }
}
</script>

<style>
/* Legacy Vant toast is suppressed — KmToast handles all notifications. */
.van-toast { display: none !important; }
*, :after, :before { box-sizing: border-box; }

/* ============================================================
   DesktopNav (≥960px) is 64px tall and fixed at top.
   Home's own top bar is hidden on desktop (DesktopNav replaces it).
   Other pages' top bars get shifted down so they sit below DesktopNav.
   ============================================================ */
@media (min-width: 960px) {
  /* Home page fully delegates its top nav to DesktopNav */
  .kh-top { display: none !important; }
  .km-home { padding-top: 64px !important; }

  /* Other pages keep their page-specific top bars (back / filter / title / save)
     but shift them down below DesktopNav and reserve room */
  .kc-top, .km-top, .m-top, .d-top { top: 64px !important; }
  .km-cam, .km-chats, .km-info, .km-page, .km-profile,
  .matches, .disc {
    padding-top: 120px !important; /* 64 DesktopNav + 56 page top bar */
  }
  .lottery { padding-top: 116px !important; /* 64 + 52 Vant nav-bar */ }
  .lottery .van-nav-bar { position: sticky; top: 64px; z-index: 39; }
}
</style>
